import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type CallbackRef<T> = (ref: T | null) => void;
type Ref<T> = React.MutableRefObject<T> | CallbackRef<T>;
export default function mergeRefs<T>(refA?: Ref<T | null> | null, refB?: Ref<T | null> | null): React.RefCallback<T> {
  const toFnRef = <T>(ref?: Ref<T | null> | null) => !ref || typeof ref === 'function' ? ref : (value: T | null) => { ref.current = value; };

  const a = toFnRef(refA);
  const b = toFnRef(refB);
  return (value: T | null) => {
    if (typeof a === 'function') a(value);
    if (typeof b === 'function') b(value);
  };
}

export function splitArrayIntoChunks<T>(array: T[], chunkSize: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
}